'use strict'

import router from './../router/index'
import store from './../store/index'
import axios from 'axios'

const apiUrl = process.env.VUE_APP_ROOT_API

const mainInit = () => {
  const token = localStorage.getItem(process.env.VUE_APP_JWT_NAME)
  if (token) { // ada token    
    axios.defaults.headers.common['Authorization'] = token
    // get user info from server
    axios.get(apiUrl+'/userman/info') 
    .then(response => {
      store.dispatch('loginState', { 
        user: response.data.data.user, 
        token: token, 
        vendor: response.data.data.vendor 
      })
      router.push(store.getters.userHome)
    })
    .catch(error => {
      console.log(error)
      store.dispatch('logoutState')
      router.push('/')
    })
  } 
}

export default mainInit